<template>
  <div class="barData">
    <v-chart :options="barData" id="echart3" auto-resize @click="onEveryBar"></v-chart>
    <div
      class="no-chart-data"
      style="color:#D3D3D3;font-size:20px;"
      v-show="isNodata"
    >Temporarily no data</div>
  </div>
</template>

<script>
let setOption = () => {
  let barColor = [
    "#5C89FF",
    "#7C6AF2",
    "#C95FF2",
    "#FF6383",
    "#FF9F40",
    "#FFCB48",
    "#31DC72",
    "#26DAD0",
    "#5CB3FF",
    "#8290FF",
    "#EF6BBB",
    "#FF7979",
    "#EBE300",
    "#26E7C7",
    "#13BAED"
  ];
  let result = [];
  for (let i = 0; i < barColor.length; i++) {
    result.push({
      type: "bar",
      barWidth: "15%", //调整双柱状图之间的间隔的
      label: {
        normal: {
          show: true,
          color: "#4E5671",
          position: "right"
        }
      },
      itemStyle: {
        normal: {
          color: barColor[i]
        }
      }
    });
  }
  return result;
};

export default {
  name: "EBar",
  // props: ["echartsData"],
  props: {
    echartsData: {},
    // 控制柱状图是否横向显示
    isHorizontal: {
      default: true
    },
    numShow: {
      type: Boolean,
      default: false
    },
    isNodata: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.setOptions();
    window.addEventListener("resize", () => {
      this.myChart3.resize();
    });
  },
  data() {
    return {
      barData: {},
      colorLength: 0,
      myChart3: ""
    };
  },
  methods: {
    setOptions() {
      let echarts = require("echarts");
      let newResultData = this.$lodash.cloneDeep(this.echartsData);

      if (newResultData.length > 0) {
        newResultData[1].map((item, index) => {
          item = Object.assign(item, setOption()[index]);

          item.label.normal.show = this.numShow;
        });
        this.barData = this.getOptions(newResultData, this.isHorizontal);
      }
      this.myChart3 = echarts.init(document.getElementById("echart3"));
    },
    getOptions(seriesData, Horizontal) {
      let xAxisVal = JSON.parse(JSON.stringify(seriesData[0]));
      let AseriesData = JSON.parse(JSON.stringify(seriesData[1]));
      this.colorLength = AseriesData.length;

      return {
        toolbox: {
          //工具栏(下载)
          feature: {
            saveAsImage: {
              show: true,
              title: "Save as picture"
            }
          },
          right: "1%"
        },
        // title: {
        //     show: this.echartsData[0].length === 0,
        //     textStyle: {
        //         color: "LightGrey",
        //         fontSize: 20
        //     },
        //     text: "Temporarily no data",
        //     left: "center",
        //     top: "center"
        // },
        title: {
          show: false,
          text: "Emotion Distribution Bar Chart"
        },
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          // left: 100,
          top: 5,
          padding: [-5, 0, 5, 0],
          icon: "roundRect",
          orient: "horizontal", // horizontal     vertical
          // itemWidth && itemHeight 同时设置更改大小
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 5,
          textStyle: {
            fontFamily: "RCR"
          }
        },
        grid: {
          top: "10%",
          left: "2%",
          right: "2%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: Horizontal == true ? "value" : "category",
          // boundaryGap: false,
          boundaryGap: [0, 0.01],
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DFDFDF",
              width: 1
            }
          },
          axisLabel: {
            fontSize: 12,
            textStyle: {
              color: "#00000",
              fontWeight: 1,
              fontFamily: "RCR"
            }
          },
          data: xAxisVal
        },
        yAxis: {
          type: Horizontal == true ? "category" : "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#DFDFDF",
              width: 1
            }
          },
          splitLine: {
            show: false
          },
          // y axios 字体设置
          axisLabel: {
            fontSize: 12,
            textStyle: {
              color: "#00000",
              fontWeight: 1,
              fontFamily: "RCR"
            }
          },
          data: xAxisVal
        },
        series: AseriesData
      };
    },
    //点击柱状图
    onEveryBar(params) {
      this.$emit("onEveryBar", params);
    }
  },
  watch: {
    echartsData() {
      this.setOptions();
    }
  }
};
</script>

<style scoped>
.echarts {
  width: 100%;
}
.barData {
  position: relative;
}
.barData .no-chart-data {
  width: 300px;
  font-size: 25;
  font-weight: 600;
  position: absolute;
  left: 50%;
  right: 50%;
  transform: translate(-25%, -588%);
}
</style>
